import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import useProfileStore from 'src/app/common/zustand/userStore';
import { userProfile } from 'common/services/server/user-profile';
import ContainerNavBar from '../ContainerNavBar/ContainerNavBar';
import styles from './ProfileLayout.module.scss';

const ProfileLayout: React.FC = () => {
  const { setProfile, profile } = useProfileStore((state) => state);

  const [isEditNameModalOpened, setIsEditNameModalOpened] =
    useState<boolean>(false);

  useEffect(() => {
    userProfile.fetchProfile().then((data) => {
      setProfile(data);
    });
  }, []);

  return (
    <ContainerNavBar>
      <div className={styles.container}>
        <Outlet />
      </div>
    </ContainerNavBar>
  );
};

export default ProfileLayout;
